import { render } from "./stocks.vue?vue&type=template&id=3807f6f1&ts=true"
import script from "./stocks.vue?vue&type=script&lang=ts"
export * from "./stocks.vue?vue&type=script&lang=ts"

import "./stocks.vue?vue&type=style&index=0&id=3807f6f1&lang=scss"

import exportComponent from "/Users/vladdof/Documents/company-quotes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__